import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('ripple'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('ripple__circle'))
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('ripple__circle ') + _ctx.getClass('ripple__inner-circle'))
    }, null, 2 /* CLASS */)
  ], 2 /* CLASS */))
}